export let PortalSettingsKeysEnum;
(function (PortalSettingsKeysEnum) {
  PortalSettingsKeysEnum["INTEGRATIONS_ECOMMERCE_ENABLED"] = "integrations:ecommerce:enabled";
  PortalSettingsKeysEnum["INTEGRATIONS_MS_TEAMS_WELCOME_MODAL_ENABLED"] = "integrations:msteams:welcomemodal:enabled";
  PortalSettingsKeysEnum["MARKETING_EVENT_BANNER_SEEN"] = "integrations:marketing-events:settings-banner";
  PortalSettingsKeysEnum["EVENTBRITE_SETTINGS_KEY"] = "integrations:eventbrite:enabled";
})(PortalSettingsKeysEnum || (PortalSettingsKeysEnum = {}));
export const ALL_PORTAL_SETTINGS_KEYS = Object.values(PortalSettingsKeysEnum);